import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { TAG_MODEL_CLASS_NAME } from 'models/daos/tag/constants'
import { USER_MODEL_CLASS_NAME } from 'models/daos/user/constants'

const PAGE_MODEL_CLASS_NAME = 'Page'

const PAGE_MODEL_KEY = {
  TITLE: 'title',
  DESCRIPTION: 'description',
  IMG: 'img',
  SHARE_IMG: 'shareImg',
  SLUG: 'slug',
  NAME: 'name',
  CONTENT: 'content',
  PUBLISHED_AT: 'publishedAt',
  FEATURED_AT: 'featuredAt',
  CATEGORIES: 'categories',
  RECOMMENDED: 'recommended',
  TAGS: 'tags',
  USER: 'user'
}

const PAGE_MODEL_KEY_POINTER = PAGE_MODEL_KEY.SLUG
const PAGE_MODEL_VALIDATOR = {
  [PAGE_MODEL_KEY.ID]: 24,
  [PAGE_MODEL_KEY.TITLE]: [
    5,
    60
  ],
  [PAGE_MODEL_KEY.DESCRIPTION]: [
    120,
    160
  ],
  [PAGE_MODEL_KEY.SLUG]: [
    1,
    6
  ],
  [PAGE_MODEL_KEY.NAME]: [
    3,
    20
  ],
  [PAGE_MODEL_KEY.CATEGORIES]: [
    0,
    2
  ],
  [PAGE_MODEL_KEY.TAGS]: [
    0,
    12
  ],
  [PAGE_MODEL_KEY.RECOMMENDED]: [
    0,
    3
  ]
}

const PAGE_MODEL_PLACEHOLDER = {
  [PAGE_MODEL_KEY.TITLE]: 'The Page Title',
  [PAGE_MODEL_KEY.DESCRIPTION]: 'This page will help you understand how to become happy.',
  [PAGE_MODEL_KEY.TAGS]: 'Page, Happiness, Joy',
  [PAGE_MODEL_KEY.IMG]: 'https//cdn.gymaholic.co/articles/fitness/21-how-to-become-happy/1-how-to-become-happy.jpg',
  [PAGE_MODEL_KEY.SHARE_IMG]: 'https//cdn.gymaholic.co/articles/fitness/21-how-to-become-happy/share-how-to-become-happy-1.jpg',
  [PAGE_MODEL_KEY.SLUG]: 'how-to-become-happy',
  [PAGE_MODEL_KEY.NAME]: 'about',
  [PAGE_MODEL_KEY.RECOMMENDED]: '10, 5, (page id)',
  [PAGE_MODEL_KEY.PUBLISHED_AT]: false,
  [PAGE_MODEL_KEY.CONTENT]: '# Here\'s where the magic happen'
}

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const PAGE_MODEL_ASSOCIATION = {
  PAGE_MODEL_CLASS_NAME,
  [PAGE_MODEL_KEY.CATEGORIES]: CATEGORY_MODEL_CLASS_NAME,
  [PAGE_MODEL_KEY.RECOMMENDED]: PAGE_MODEL_CLASS_NAME,
  [PAGE_MODEL_KEY.TAGS]: TAG_MODEL_CLASS_NAME,
  [PAGE_MODEL_KEY.USER]: USER_MODEL_CLASS_NAME
}

export {
  PAGE_MODEL_CLASS_NAME,
  PAGE_MODEL_KEY,
  PAGE_MODEL_KEY_POINTER,
  PAGE_MODEL_VALIDATOR,
  PAGE_MODEL_PLACEHOLDER,
  PAGE_MODEL_ASSOCIATION
}
